import { WHY_US, BUSINESS } from "@/data";
import { SectionHeading } from "./Buttons";
import * as Icons from "lucide-react";

export default function WhyChooseUs() {
  return (
    <section id="why" data-testid="why-section" className="relative bg-white py-20 md:py-28 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="Why Locals Choose Us"
          title={<>Why Miami Gardens<br />chooses <span className="text-brand-red">Your Phone Plug.</span></>}
          sub="We're not just an online store. We're a real local storefront where you can walk in, talk to a real person, get your phone checked, compare options, and leave with a solution."
          testid="why-heading"
        />

        <div className="mt-12 md:mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {WHY_US.map((w, i) => {
            const Icon = Icons[w.icon] || Icons.CheckCircle2;
            const isFeatured = i === 0;
            return (
              <div
                key={w.title}
                data-testid={`why-card-${i}`}
                className={`card-soft-hover p-6 md:p-7 transition-all ${
                  isFeatured
                    ? "lg:col-span-2 lg:row-span-2 bg-brand-red text-white border-brand-red rounded-2xl shadow-xl glow-red"
                    : "card-soft"
                }`}
              >
                <div className={`w-11 h-11 rounded-xl grid place-items-center mb-5 ${
                  isFeatured ? "bg-white/15 text-white" : "bg-green-50 border border-green-100 text-brand-red"
                }`}>
                  <Icon className="w-5 h-5" />
                </div>
                <h3 className={`font-display font-extrabold tracking-tight ${
                  isFeatured ? "text-3xl md:text-4xl text-white" : "text-xl text-brand-navy"
                }`}>
                  {w.title}
                </h3>
                <p className={`mt-3 leading-relaxed ${
                  isFeatured ? "text-base md:text-lg text-white/85" : "text-sm text-slate-600"
                }`}>
                  {w.desc}
                </p>
                {isFeatured && (
                  <div className="mt-6 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-white/80">
                    <span className="w-6 h-px bg-white/60" />
                    Serving Miami Gardens since {BUSINESS.founded}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
